<aside ui-view="leftbar" class="hidden-sm hidden-xs hidden-md col-xl-2">
  <!-- <patient-today></patient-today> -->
</aside>
<div ui-view="patientmain" class="col-sm-12 col-md-12 col-lg-10 col-xl-7">
  <patient-list></patient-list>
</div>
